module.exports = "<p>\n  qb works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/qb/qb.component.html
// module id = ./src/app/qb/qb.component.html
// module chunks = main